import React, { useContext } from "react"
import Context from "../utils/Context"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowsSpin, faCircleDot, faCircleExclamation, faCircleMinus, faCircleStop, faPlug } from "@fortawesome/free-solid-svg-icons"

export default function RobotStatus({ robot }) {
    const context = useContext(Context)

    let diagMsg = '', color = '', icon = '', text = ''

    if (context.currentBatteries[robot] && context.currentBatteries[robot].current > 0) {
        color = "has-text-warning"
        icon = faPlug
        text = "Charging"
    } else if (context.currentErrors[robot] && context.currentErrors[robot].length > 0) {
        color = "has-text-danger"
        icon = faCircleExclamation
        text = "Error"
        diagMsg = context.currentErrors[robot].filter((flag) => flag.type === 0).map((flag) => flag.name).toString()
    } else if (context.currentFeedback[robot] && context.currentFeedback[robot].status === 'executing') {
        switch (context.currentFeedback[robot].actions[0].status) {
            case 'blockedStatus':
                color = "has-text-danger"
                icon = faCircleMinus
                text = "Blocked"
                break

            case 'emergencyStatus':
                color = "has-text-danger"
                icon = faCircleStop
                text = "In Emergency Status"
                break

            default:
                color = "has-text-success-dark fa-spin"
                icon = faArrowsSpin
                text = "In Mission: " + context.currentFeedback[robot].name
                break
        }
    } else {
        color = "has-text-link"
        icon = faCircleDot
        text = "Idle"
    }

    let hoverStyle = {}
    if (diagMsg !== "") hoverStyle = { cursor: 'help' }

    return (
        <div>
            <span className={`is-small ${color} mr-2`} title={diagMsg} style={hoverStyle}><FontAwesomeIcon icon={icon} /></span>

            <span className={`${color}`} title={diagMsg} style={hoverStyle}>{text}</span>
        </div>
    )
}